import { produce } from 'immer';
import { createModel, RematchDispatch } from '@rematch/core';

import baseEntity from './base.entity';
import { RootModel } from '../models';
import { fetchAgentsApi } from '../../services/agent';
import { AgentTypes } from '../../types/agent.type';

export const storeName = 'agentEntity';

export const agentEntity = createModel<RootModel>()({
  name: storeName,
  state: { ids: {} },
  reducers: {
    ...baseEntity,
    saveIds: produce((state, entities) => {
      (entities || []).forEach((entity: AgentTypes) => {
        state.ids[entity.id] = entity;
      });
    }),
  },
  effects: (dispatch: RematchDispatch<typeof agentEntity>) => ({
    async fetchAgents(payload) {
      const resp = await fetchAgentsApi(payload);
      if (!resp) return null;
      const { data } = resp;
      this.saveIds(data.content);
      return resp;
    },
  }),
});

export default agentEntity;
